// 分享的工具类
import {shareOnMobile} from "react-mobile-share";
import {UrlConfig} from "../../config/url-config.ts";
import {JudgmentPlatform} from "../checkPlatform.ts";
import {LOGO_BASE64} from "../../config/config.ts";

export class ShareUtil {

    // 在CGTN的ios端原生app上进行分享
    public static shareInIosCGTNApp(imgJson: string) {
        // 当前时间
        const currentTime = new Date().getTime();
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        window.webkit.messageHandlers.share.postMessage({
            title: "Join and compete with me in Word Arena!",
            subTitle: "Join and compete with me in Word Arena!",
            iconUrl: imgJson,
            url: UrlConfig.SHARE_URL + `?st=${currentTime}`
        });
    }

    // 在CGTN的ios端原生app上进行分享 链接
    public static shareUrlInIosCGTNApp(url: string, imgJson: string) {
        // 当前时间
        const currentTime = new Date().getTime();
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        window.webkit.messageHandlers.share.postMessage({
            title: "Join and compete with me in Word Arena!",
            subTitle: "Join and compete with me in Word Arena!",
            iconUrl: imgJson,
            url: url + `?t=${currentTime}`
        });
    }

    // 在在CGTN的安卓端原生app上进行分享
    public static shareInAndroidCGTNApp(dataUrl: string) {
        // 当前时间
        const currentTime = new Date().getTime();
        // 将图片dataUrl转换为base64编码
        const imgJson = dataUrl.replace(/^data:image\/(png|jpg);base64,/, '')
        const jsonAndroid = "{\n" +
            "    \"title\": \"Join and compete with me in Word Arena!\",\n" +
            "    \"subTitle\": \"Join and compete with me in Word Arena!\",\n" +
            "    \"iconUrl\": \"iconurl\",\n" +
            "    \"url\": \"" + UrlConfig.SHARE_URL + `?currentTime=${currentTime}` + "\",\n" +
            "    \"image\": \"" + imgJson + "\"\n" +
            "}";
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        window.YSPAndroid.share(jsonAndroid);
    }

    // 在在CGTN的安卓端原生app上进行分享链接
    public static shareUrlInAndroidCGTNApp(url: string, imgJson?: string) {
        const json = {
            title: "Word Arena",
            subTitle: "Join and compete with me in Word Arena!",
            iconUrl: "iconurl",
            url: url,
            image: imgJson
        }
        const jsonStr = JSON.stringify(json)
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        window.YSPAndroid.share(jsonStr);
    }

    public static shareOnTwitter() {
        const tweetUrl = "https://twitter.com/intent/tweet";
        const text = encodeURIComponent("Join and compete with me in Word Arena!");
        const url = encodeURIComponent(UrlConfig.SHARE_URL);
        window.open(tweetUrl + "?text=" + text + "&url=" + url);
    }

    // 在web页面中进行分享
    public static async shareInWeb(base64String: string) {
        // 创建一个Blob对象
        const byteCharacters = atob(base64String); // 解码Base64
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], {type: 'image/png'});

        // 准备分享的文件数组
        const filesArray = [new File([blob], 'image.png', {type: 'image/png'})];
        if (navigator.share) {
            try {
                // 当前时间
                const currentTime = new Date().getTime();
                // 调用分享API
                await navigator.share({
                    title: 'Word Arena',
                    text: 'Join and compete with me in Word Arena!',
                    url: UrlConfig.SHARE_URL + `?currentTime=${currentTime}`,
                    files: filesArray
                })
            } catch (error) {
                console.error('share fail：', error);
                alert(`Sharing Failure.${error}`);
            }
        } else {
            try {
                await navigator.clipboard.writeText("https://news.cgtn.com/game/wordarena/index.html")
                // 如果不支持分享的浏览器
                alert('Url has been copy to clipboard, please open in browser manually!');
            } catch (error) {
                console.error('share fail：', error);
                alert(`Sharing Failure: ${error}`);
            }

        }
    }

    // 在手机浏览器上进行分享，传进来的不是base64，而是截图之后的dataUrl，这个在微信上无法正常分享
    public static shareInBrowser(dataUrl: string) {
        // 当前时间
        const currentTime = new Date().getTime();
        // 如果是在常规浏览器上打开
        shareOnMobile({
            title: "Word Arena",
            text: "Join and compete with me in Word Arena!",
            url: UrlConfig.SHARE_URL + `?t=${currentTime}`,
            images: [dataUrl],
        })
    }

    // 分享链接
    public static async share(url: URL, onError: (e: string) => void, dataUrl?: string) {
        try {
            const platform = JudgmentPlatform.getPlatform();
            const searchParams = new URLSearchParams(url.search);
            // 当前时间
            const currentTime = new Date().getTime();
            searchParams.set('t', String(currentTime));
            url.search = searchParams.toString();
            if (platform === "IOS" || platform === "IOS_dark") {
                this.shareUrlInIosCGTNApp(url.href, dataUrl ?? LOGO_BASE64)
                // if (dataUrl) {
                //     shareOnMobile({
                //         title: "Word Arena",
                //         text: "Join and compete with me in Word Arena!",
                //         url: url.href,
                //         images: [dataUrl]
                //     })
                // } else {
                //     shareOnMobile({
                //         title: "Word Arena",
                //         text: "Join and compete with me in Word Arena!",
                //         url: url.href,
                //         images: [LOGO_BASE64]
                //     })
                // }
            } else if (platform === "Android" || platform === "Android_dark") {
                let imgJson: string | undefined = undefined;
                if (dataUrl) {
                    // 将图片dataUrl转换为base64编码
                    imgJson = dataUrl?.replace(/^data:image\/(png|jpg);base64,/, '')
                }
                this.shareUrlInAndroidCGTNApp(url.href, imgJson)
            } else {
                if (dataUrl) {
                    shareOnMobile({
                        title: "Word Arena",
                        text: "Join and compete with me in Word Arena!",
                        url: url.href,
                        images: [dataUrl]
                    })
                } else {
                    shareOnMobile({
                        title: "Word Arena",
                        text: "Join and compete with me in Word Arena!",
                        url: url.href,
                        images: [LOGO_BASE64]
                    })
                }
            }
        } catch (e) {
            onError(`${e}`)
        }
    }
}